module.exports = __webpack_public_path__ + "static/media/Hand-Gel-Belgium-Getty_tablet.ea6bca44.jpg";